import React, { useState, useEffect } from "react";
import { WebLink, SiteWide, Images, CountrySelector } from "./customComponents";
import { useNavigate, useLocation } from 'react-router-dom';

import APIRequests from '../utility/APIRequests';
import { staticCountries } from '../utility/countries';
import { setUserSession, setUserFinance, setUserToken } from '../utility/CommonAuth';
import Helper1, { notify } from '../utility/Helper1';
import { Alert } from "../alertServices";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { authActions } from '../redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import { userSelect, allRemoteSettingsSelect, homeScreenStatSelect } from '../redux/selectors/index';

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import PublicIcon from "@mui/icons-material/Public";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import GroupsIcon from "@mui/icons-material/Groups";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";

const bacggroundImage = require('../images/home-2.jpg');
let referralToUse = localStorage?.getItem('ref') != 'null' ? localStorage?.getItem('ref') : '';

function Signup() {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [withdrawalPin, setWithdrawalPin] = useState('');
    const [showPin, setShowPin] = useState(false);
    const [password, setPassword] = useState('');
    const [loading, changeLoading] = useState(false);
    const [fullPageLoading, setFullPageLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [country, setCountry] = useState(0);
    const [phone, setPhone] = useState('');
    const [phoneCode, setPhoneCode] = useState('');
    const [referral, setReferrals] = useState(referralToUse);
    const [agree, setAgree] = useState(false);
    const [focused, setFocused] = useState(null);

    const [walletAddress, setWalletAddress] = useState('');
    const [bank, setBankName] = useState('');
    const [accountName, setAccountName] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [depositMethod, setDepositMethod] = useState(100);

    const site_settings = useSelector(allRemoteSettingsSelect);
    const search = useLocation().search;
    const referalLink = new URLSearchParams(search).get("ref");

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if ((referalLink != '') && (referalLink != null) && (referalLink != 'null')) {
            localStorage.setItem('ref', referalLink);
            setReferrals(referalLink);
        }
    }, []);

    const checkboxHandler = () => { setAgree(!agree); };

    const doRegister = async (e) => {
        if (!agree) { notify('You must accept the terms and conditions to continue', 0); return; }
        e.preventDefault();
        changeLoading(true);
        setFullPageLoading(true);
        let financeLoad;
        let payLoad = { depositMethod, username, email, password, country, phone, withdrawalPin, referral };
        if (depositMethod == 0) {
            financeLoad = { bank, accountName, accountNumber };
        } else {
            financeLoad = { walletAddress };
        }
        dispatch(authActions.onSignUp("account/register", Object.assign({}, payLoad, financeLoad), response => {
            if (response.code != 0) {
                localStorage.removeItem('ref');
                navigate('/personal-information');
            } else {
                notify(response.msg, response.code);
            }
            changeLoading(false);
            setFullPageLoading(false);
        }));
    };

    const changeCountry = (countryId) => {
        let selectedCountry = staticCountries.filter(e => e.id == countryId);
        setCountry(countryId);
        let countryPhoneCode = selectedCountry?.[0]?.phonecode;
        setPhoneCode(countryPhoneCode ? `+${countryPhoneCode}` : '');
    };

    // ── shared input style ──────────────────────────────────────────────────
    const inputStyle = (field) => ({
        width: "100%",
        borderRadius: 12,
        padding: "12px 14px 12px 40px",
        border: `1.5px solid ${focused === field ? "#2563eb" : "rgba(59,130,246,0.18)"}`,
        background: focused === field ? "#f0f7ff" : "#f8fafc",
        color: "#0f172a",
        fontSize: 13,
        fontFamily: "'DM Sans',sans-serif",
        outline: "none",
        boxSizing: "border-box",
        transition: "all 0.2s",
        boxShadow: focused === field ? "0 0 0 3px rgba(59,130,246,0.1)" : "none"
    });

    const iconStyle = (field) => ({
        position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)",
        color: focused === field ? "#2563eb" : "#94a3b8", fontSize: 16,
        transition: "color 0.2s", pointerEvents: "none"
    });

    const labelStyle = {
        color: "#334155", fontSize: 12, fontWeight: 600,
        fontFamily: "'DM Sans',sans-serif", display: "block", marginBottom: 5
    };

    const features = [
        { icon: <ChatBubbleOutlineIcon style={{ fontSize: 20 }} />, text: "Chat with people across the world" },
        { icon: <GroupsIcon style={{ fontSize: 20 }} />, text: "Build a community that loves you" },
        { icon: <EmojiEmotionsIcon style={{ fontSize: 20 }} />, text: "Stay active, have fun, be yourself" },
        { icon: <MonetizationOnOutlinedIcon style={{ fontSize: 20 }} />, text: "Earn passive rewards as you chat" },
    ];

    return (
        <SiteWide>
            <div style={{
                minHeight: "100vh", display: "flex", alignItems: "stretch",
                background: "#f8fafc", fontFamily: "'DM Sans',sans-serif"
            }}>

                {/* ── Left panel ── */}
                <div style={{
                    flex: "0 0 40%", position: "relative", overflow: "hidden",
                    background: "linear-gradient(150deg,#0f172a 0%,#1e3a8a 35%,#1d4ed8 70%,#3b82f6 100%)",
                    display: "flex", flexDirection: "column",
                    padding: "40px 36px", boxSizing: "border-box"
                }}
                    className="auth-left-panel"
                >
                    <div style={{
                        position: "absolute", top: -80, right: -80, width: 300, height: 300,
                        borderRadius: "50%", background: "rgba(96,165,250,0.12)", filter: "blur(70px)"
                    }} />
                    <div style={{
                        position: "absolute", bottom: 60, left: -60, width: 260, height: 260,
                        borderRadius: "50%", background: "rgba(139,92,246,0.1)", filter: "blur(60px)"
                    }} />

                    {/* Logo */}
                    <div style={{ position: "relative", zIndex: 1, marginBottom: "auto" }}>
                        <Images
                            height="40px"
                            src={site_settings?.site_settings?.logo}
                            alt="logo"
                            style={{ filter: "brightness(0) invert(1)" }}
                        />
                    </div>

                    {/* Hero text */}
                    <div style={{ position: "relative", zIndex: 1, marginBottom: 40 }}>
                        <h1 style={{
                            color: "#ffffff", fontSize: 32, fontWeight: 800,
                            fontFamily: "'Syne',sans-serif", lineHeight: 1.2, margin: "0 0 12px"
                        }}>
                            Talk, connect,<br />
                            <span style={{ color: "#93c5fd" }}>and earn</span><br />
                            along the way.
                        </h1>
                        <p style={{ color: "rgba(219,234,254,0.6)", fontSize: 13, margin: 0, lineHeight: 1.6 }}>
                            Create a free account and start chatting with people from all over the world — rewards come naturally.
                        </p>
                    </div>

                    {/* Features */}
                    <div style={{ position: "relative", zIndex: 1, display: "flex", flexDirection: "column", gap: 12 }}>
                        {features.map((f, i) => (
                            <div key={i} style={{ display: "flex", alignItems: "center", gap: 12 }}>
                                <div style={{
                                    width: 34, height: 34, borderRadius: 9, flexShrink: 0,
                                    background: "rgba(255,255,255,0.09)", backdropFilter: "blur(8px)",
                                    border: "1px solid rgba(255,255,255,0.1)",
                                    display: "flex", alignItems: "center", justifyContent: "center", color: "#93c5fd"
                                }}>
                                    {f.icon}
                                </div>
                                <span style={{ color: "rgba(219,234,254,0.7)", fontSize: 12, fontFamily: "'DM Sans',sans-serif" }}>
                                    {f.text}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* ── Right panel (form) ── */}
                <div style={{
                    flex: 1, display: "flex", alignItems: "flex-start", justifyContent: "center",
                    padding: "32px 24px", overflowY: "auto"
                }}>
                    <div style={{ width: "100%", maxWidth: 400 }}>

                        {/* Heading */}
                        <h2 style={{
                            color: "#0f172a", fontSize: 24, fontWeight: 800,
                            fontFamily: "'Syne',sans-serif", margin: "0 0 4px"
                        }}>
                            Create Account
                        </h2>
                        <p style={{ color: "#64748b", fontSize: 13, margin: "0 0 24px" }}>
                            Already have an account?{" "}
                            <WebLink to="/signin" style={{ color: "#2563eb", fontWeight: 600, textDecoration: "none" }}>
                                Sign in
                            </WebLink>
                        </p>

                        <form onSubmit={doRegister} style={{ display: "flex", flexDirection: "column", gap: 14 }}>

                            {/* Username */}
                            <div>
                                <label style={labelStyle}>Username</label>
                                <div style={{ position: "relative" }}>
                                    <PersonOutlineIcon style={iconStyle('username')} />
                                    <input type="text" value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        onFocus={() => setFocused('username')} onBlur={() => setFocused(null)}
                                        placeholder="Choose a username" required style={inputStyle('username')} />
                                </div>
                            </div>

                            {/* Email */}
                            <div>
                                <label style={labelStyle}>Email</label>
                                <div style={{ position: "relative" }}>
                                    <MailOutlineIcon style={iconStyle('email')} />
                                    <input type="email" value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        onFocus={() => setFocused('email')} onBlur={() => setFocused(null)}
                                        placeholder="Enter your email" required style={inputStyle('email')} />
                                </div>
                            </div>

                            {/* Password */}
                            <div>
                                <label style={labelStyle}>Password</label>
                                <div style={{ position: "relative" }}>
                                    <LockOutlinedIcon style={iconStyle('password')} />
                                    <input type={showPassword ? "text" : "password"} value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        onFocus={() => setFocused('password')} onBlur={() => setFocused(null)}
                                        placeholder="Create a password" required
                                        style={{ ...inputStyle('password'), paddingRight: 44 }} />
                                    <button type="button" onClick={() => setShowPassword(!showPassword)}
                                        style={{
                                            position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
                                            background: "none", border: "none", cursor: "pointer",
                                            color: "#94a3b8", display: "flex", alignItems: "center", padding: 0
                                        }}>
                                        {showPassword ? <VisibilityOffIcon style={{ fontSize: 16 }} /> : <VisibilityIcon style={{ fontSize: 16 }} />}
                                    </button>
                                </div>
                            </div>

                            {/* PIN */}
                            <div>
                                <label style={labelStyle}>Withdrawal PIN <span style={{ color: "#94a3b8", fontWeight: 400 }}>(4 digits)</span></label>
                                <div style={{ position: "relative" }}>
                                    <CreditCardIcon style={iconStyle('pin')} />
                                    <input type={showPin ? "text" : "password"} value={withdrawalPin}
                                        onChange={(e) => setWithdrawalPin(e.target.value)}
                                        onFocus={() => setFocused('pin')} onBlur={() => setFocused(null)}
                                        placeholder="4-digit PIN" maxLength={4} required
                                        style={{ ...inputStyle('pin'), paddingRight: 44 }} />
                                    <button type="button" onClick={() => setShowPin(!showPin)}
                                        style={{
                                            position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
                                            background: "none", border: "none", cursor: "pointer",
                                            color: "#94a3b8", display: "flex", alignItems: "center", padding: 0
                                        }}>
                                        {showPin ? <VisibilityOffIcon style={{ fontSize: 16 }} /> : <VisibilityIcon style={{ fontSize: 16 }} />}
                                    </button>
                                </div>
                            </div>

                            {/* Country */}
                            <div>
                                <label style={labelStyle}>Country</label>
                                <CountrySelector
                                    value={country}
                                    onChange={(countryId) => changeCountry(countryId)}
                                    onFocus={() => setFocused('country')}
                                    onBlur={() => setFocused(null)}
                                    focused={focused === 'country'}
                                />
                            </div>

                            {/* Phone */}
                            <div>
                                <label style={labelStyle}>Phone Number</label>
                                <div style={{ display: "flex", gap: 0 }}>
                                    {phoneCode && (
                                        <div style={{
                                            borderRadius: "12px 0 0 12px", padding: "12px 10px",
                                            background: "rgba(59,130,246,0.06)",
                                            border: "1.5px solid rgba(59,130,246,0.18)", borderRight: "none",
                                            color: "#2563eb", fontSize: 12, fontWeight: 700, fontFamily: "'Syne',sans-serif",
                                            whiteSpace: "nowrap", display: "flex", alignItems: "center"
                                        }}>
                                            {phoneCode}
                                        </div>
                                    )}
                                    <div style={{ position: "relative", flex: 1 }}>
                                        <PhoneIcon style={{
                                            position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)",
                                            color: focused === 'phone' ? "#2563eb" : "#94a3b8", fontSize: 16,
                                            transition: "color 0.2s", pointerEvents: "none"
                                        }} />
                                        <input type="text" value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                            onFocus={() => setFocused('phone')} onBlur={() => setFocused(null)}
                                            placeholder="XXX XXX XXXX" required
                                            style={{
                                                ...inputStyle('phone'),
                                                borderRadius: phoneCode ? "0 12px 12px 0" : 12,
                                                borderLeft: phoneCode ? "none" : undefined
                                            }} />
                                    </div>
                                </div>
                            </div>

                            {/* Referral (optional) */}
                            <div>
                                <label style={labelStyle}>Referral Code <span style={{ color: "#94a3b8", fontWeight: 400 }}>(optional)</span></label>
                                <input type="text" value={referral}
                                    onChange={(e) => setReferrals(e.target.value)}
                                    placeholder="Enter referral code"
                                    style={{
                                        ...inputStyle('ref'),
                                        paddingLeft: 14,
                                    }} />
                            </div>

                            {/* Terms */}
                            {(site_settings?.site_settings?.term ?? '') != '' && (
                                <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
                                    <input
                                        type="checkbox" id="agree"
                                        checked={agree} onChange={checkboxHandler}
                                        style={{
                                            width: 16, height: 16, marginTop: 2, flexShrink: 0,
                                            accentColor: "#2563eb", cursor: "pointer"
                                        }}
                                    />
                                    <label htmlFor="agree" style={{ color: "#64748b", fontSize: 12, lineHeight: 1.5, cursor: "pointer" }}>
                                        I agree to the{" "}
                                        <WebLink to="/term" style={{ color: "#2563eb", fontWeight: 600, textDecoration: "none" }}>
                                            Terms & Conditions
                                        </WebLink>
                                    </label>
                                </div>
                            )}

                            {/* Submit */}
                            <button
                                type="submit"
                                disabled={loading || !agree}
                                style={{
                                    width: "100%", borderRadius: 12, padding: "14px 0",
                                    border: "none", marginTop: 4,
                                    background: (loading || !agree) ? "rgba(37,99,235,0.35)" : "linear-gradient(135deg,#1d4ed8,#2563eb)",
                                    color: "#fff", fontSize: 14, fontWeight: 700,
                                    fontFamily: "'Syne',sans-serif",
                                    cursor: (loading || !agree) ? "not-allowed" : "pointer",
                                    boxShadow: (loading || !agree) ? "none" : "0 6px 20px rgba(37,99,235,0.35)",
                                    display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                                    transition: "all 0.2s"
                                }}
                            >
                                {loading ? (
                                    <div style={{
                                        width: 18, height: 18, border: "2.5px solid rgba(255,255,255,0.4)",
                                        borderTopColor: "#fff", borderRadius: "50%", animation: "spin 0.8s linear infinite"
                                    }} />
                                ) : (
                                    <>Create Account <ArrowForwardIcon style={{ fontSize: 16 }} /></>
                                )}
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes spin { to { transform: rotate(360deg); } }
                @media (max-width: 640px) {
                    .auth-left-panel { display: none !important; }
                }
            `}</style>
        </SiteWide>
    );
}

export default Signup;